<template>
  <div class="chat-agent-container-preview">
    <div v-if="error !== ''" class="error-message">{{ error }}</div>
    <div v-else-if="isLoading === true" class="loading-indicator">
      <span class="loading loading-dots loading-lg text-primary"></span>
    </div>
    <div v-else class="chat-wrapper-preview">
      <div id="chat-container-preview" class="chat-container-preview">
        <div class="chat-header-preview">
          <div class="chat-header-content-preview">
            <div class="agent-info-preview">
              <div class="agent-avatar-preview">
                <svg v-if="hasCustomLogo === false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none"><path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"/><path fill="currentColor" d="M9.107 5.448c.598-1.75 3.016-1.803 3.725-.159l.06.16l.807 2.36a4 4 0 0 0 2.276 2.411l.217.081l2.36.806c1.75.598 1.803 3.016.16 3.725l-.16.06l-2.36.807a4 4 0 0 0-2.412 2.276l-.081.216l-.806 2.361c-.598 1.75-3.016 1.803-3.724.16l-.062-.16l-.806-2.36a4 4 0 0 0-2.276-2.412l-.216-.081l-2.36-.806c-1.751-.598-1.804-3.016-.16-3.724l.16-.062l2.36-.806A4 4 0 0 0 8.22 8.025l.081-.216zM11 6.094l-.806 2.36a6 6 0 0 1-3.49 3.649l-.25.091l-2.36.806l2.36.806a6 6 0 0 1 3.649 3.49l.091.25l.806 2.36l.806-2.36a6 6 0 0 1 3.49-3.649l.25-.09l2.36-.807l-2.36-.806a6 6 0 0 1-3.649-3.49l-.09-.25zM19 2a1 1 0 0 1 .898.56l.048.117l.35 1.026l1.027.35a1 1 0 0 1 .118 1.845l-.118.048l-1.026.35l-.35 1.027a1 1 0 0 1-1.845.117l-.048-.117l-.35-1.026l-1.027-.35a1 1 0 0 1-.118-1.845l.118-.048l1.026-.35l.35-1.027A1 1 0 0 1 19 2"/></g></svg>
                 <img v-else :src="customLogoUrl" alt="Agent Logo" style="width: 100%; height: 100%; object-fit: contain; border-radius: 50%; padding: 2%;" />
              </div>
              <div class="agent-details-preview">
                <span id="agent-name-preview" class="agent-name-preview">{{ agentName }}</span>
                <span class="agent-status-preview">Online</span>
              </div>
            </div>
             <button @click="startNewChat" class="btn btn-sm btn-circle btn-ghost" title="Start New Chat">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"/></svg>
             </button>
          </div>
        </div>

        <div id="chat-content-preview" ref="chatContentRef" class="chat-content-preview">
           <div v-for="messageGroup in messages" :key="messageGroup.groupId"
               :class="['chat-message-group-preview', messageGroup.type + '-group']"
               :dir="messageGroup.dir">
            <div v-for="message in messageGroup.messages" :key="message.id"
                :class="['chat-message-preview', message.type]"
                :data-message-id="message.messageId || message.id"
                :dir="message.dir">
                 <div v-if="message.isLoading === true" class="message-content-preview typing-indicator-bubble">
                   <svg width="60" height="23" viewBox="0 0 120 40" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="8" fill="currentColor"><animateTransform attributeName="transform" type="translate" values="0,0;0,-15;0,0;0,0" keyTimes="0;0.3;0.6;1" calcMode="spline" keySplines="0.42 0 0.58 1;0.42 0 0.58 1;0.42 0 0.58 1" dur="1.2s" repeatCount="indefinite" begin="0s"/></circle><circle cx="60" cy="20" r="8" fill="currentColor"><animateTransform attributeName="transform" type="translate" values="0,0;0,-15;0,0;0,0" keyTimes="0;0.3;0.6;1" calcMode="spline" keySplines="0.42 0 0.58 1;0.42 0 0.58 1;0.42 0 0.58 1" dur="1.2s" repeatCount="indefinite" begin="0.2s"/></circle><circle cx="100" cy="20" r="8" fill="currentColor"><animateTransform attributeName="transform" type="translate" values="0,0;0,-15;0,0;0,0" keyTimes="0;0.3;0.6;1" calcMode="spline" keySplines="0.42 0 0.58 1;0.42 0 0.58 1;0.42 0 0.58 1" dur="1.2s" repeatCount="indefinite" begin="0.4s"/></circle></svg>
                 </div>
                 <div v-else class="message-content-preview" v-html="sanitizeHtml(message.text)"></div>
                 <div v-if="message.type === 'agent' && message.isLoading === false && agentConfig.enableFeedbackButtons !== false && agentConfig.enableFeedbackButtons !== 'false'" class="feedback-buttons-preview">
                     <button class="feedback-btn-preview like-btn-preview" title="Like" @click="handleFeedbackClick(message.messageId, 'like')">ÃƒÂ°Ã…Â¸Ã¢â‚¬ËœÃ‚Â</button>
                     <button class="feedback-btn-preview dislike-btn-preview" title="Dislike" @click="handleFeedbackClick(message.messageId, 'dislike')">ÃƒÂ°Ã…Â¸Ã¢â‚¬ËœÃ…Â½</button>
                 </div>
            </div>
              <div v-if="messageGroup.type === 'agent' && messageGroup.suggestedResponses && messageGroup.suggestedResponses.length > 0 && agentConfig.enableSuggestedResponses !== false && agentConfig.enableSuggestedResponses !== 'false'" class="suggested-responses-container-preview">
                <button v-for="suggestion in messageGroup.suggestedResponses" :key="suggestion"
                        class="suggested-response-btn-preview"
                        @click="handleSuggestionClick(suggestion)">
                  {{ suggestion }}
                </button>
              </div>
             <div v-if="messageGroup.type === 'agent' && messageGroup.buttons && messageGroup.buttons.length > 0 && agentConfig.enableStepButtons !== false && agentConfig.enableStepButtons !== 'false'" class="step-buttons-container-preview">
                 <button v-for="(buttonConfig, buttonIndex) in messageGroup.buttons" :key="buttonIndex"
                         class="step-button-preview"
                         @click="handleStepButtonClick(buttonConfig)">
                     {{ buttonConfig.label }}
                 </button>
             </div>
           </div>
        </div>

        <div class="chat-form-wrapper-preview">
          <form @submit.prevent="sendMessage" class="chat-form-preview">
            <div class="input-wrapper-preview">
              <textarea
                v-model="userMessage"
                id="chat-input-preview"
                :placeholder="chatInputPlaceholder"
                autocomplete="off"
                required
                rows="1"
                @input="adjustTextareaHeight"
                @keydown="handleKeyDown"
                :dir="inputDirection"
              ></textarea>
              <button type="submit" id="chat-send-preview" class="send-button-preview" aria-label="Send message">
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m5 12l-.604-5.437C4.223 5.007 5.825 3.864 7.24 4.535l11.944 5.658c1.525.722 1.525 2.892 0 3.614L7.24 19.466c-1.415.67-3.017-.472-2.844-2.028zm0 0h7"/></svg>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, nextTick, computed } from 'vue';
import axios from '../api/axiosInstance';
import { globalState } from '@/globalState';
import { useToast } from 'vue-toastification';
import { marked } from 'marked';

const props = defineProps({
  agentId: {
    type: String,
    required: true,
  },
  previewData: {
    type: Object,
    default: null
  }
});

const toast = useToast();
const error = ref('');
const isLoading = ref(true);
const agentName = ref('Loading...');
const agentConfig = ref({});
const hasCustomLogo = ref(false);
const customLogoUrl = ref('');
const chatSessionId = ref('');
const userMessage = ref('');
const messages = ref([]);
const isTyping = ref(false);
const chatContentRef = ref(null);
const inputDirection = ref('ltr');
const chatInputPlaceholder = ref('Type your message...');

function escapeHtml(value) {
    const stringValue = value === undefined || value === null ? '' : String(value);
    return stringValue
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function sanitizeHtml(rawHtml) {
    const input = typeof rawHtml === 'string' ? rawHtml : (rawHtml === null || rawHtml === undefined ? '' : String(rawHtml));
    if (input.trim().length === 0) {
        return '';
    }
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString('<div>' + input + '</div>', 'text/html');
    const container = parsedDocument.body.firstChild;
    if (container === undefined || container === null) {
        return '';
    }
    const allowedTags = new Set(['div', 'span', 'p', 'br', 'hr', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'blockquote', 'code', 'pre', 'a']);
    function clean(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
            const tag = node.tagName.toLowerCase();
            if (allowedTags.has(tag) === false) {
                const parent = node.parentNode;
                while (node.firstChild !== null) {
                    parent.insertBefore(node.firstChild, node);
                }
                parent.removeChild(node);
                return;
            }
            if (tag === 'a') {
                const href = node.getAttribute('href') !== null ? node.getAttribute('href') : '';
                if (/^(https?:|mailto:|tel:|#)/i.test(href) === false) {
                    node.removeAttribute('href');
                } else {
                    node.setAttribute('target', '_blank');
                    node.setAttribute('rel', 'noopener noreferrer');
                }
            }
            if (node.hasAttribute('style') === true) {
                node.removeAttribute('style');
            }
            Array.from(node.attributes).forEach(function(attr) {
                if (/^on/i.test(attr.name) === true) {
                    node.removeAttribute(attr.name);
                }
            });
        }
        let child = node.firstChild;
        while (child !== null) {
            const nextSibling = child.nextSibling;
            clean(child);
            child = nextSibling;
        }
    }
    clean(container);
    return container.innerHTML.trim();
}

function sanitizeWindowOpenUrl(value) {
    if (value === undefined || value === null) {
        return null;
    }
    const raw = String(value).trim();
    if (raw.length === 0) {
        return null;
    }
    let parsedUrl;
    try {
        parsedUrl = new URL(raw, window.location.origin);
    } catch {
        return null;
    }
    const protocol = typeof parsedUrl.protocol === 'string' ? parsedUrl.protocol.toLowerCase() : '';
    if (protocol === 'http:' || protocol === 'https:') {
        return parsedUrl.href;
    }
    return null;
}

function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, character =>
        (character ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> character / 4).toString(16)
    );
}

function isRTL(textValue) {
    if (textValue === null || textValue === undefined || typeof textValue !== 'string' || textValue.length === 0) {
        return false;
    }
    const rtlCharacterPattern = /[\u0590-\u08FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
    return rtlCharacterPattern.test(textValue);
}

function processAIAnswer(answer) {
    if (typeof answer !== 'string') return '';
    answer = answer.trim();
    
    let parsedHtml = marked.parse(answer, { gfm: true, breaks: true });

    parsedHtml = parsedHtml.replace(/\\n/g, '<br>');

    parsedHtml = parsedHtml.replace(/^(<br\s*\/?>\s*)+/, '');
    parsedHtml = parsedHtml.replace(/<p>\s*<\/p>/g, ''); 
    return sanitizeHtml(parsedHtml);
}


function getDir(text) {
    let plainText = '';
    const processedHtml = processAIAnswer(text);
    if (typeof DOMParser !== 'undefined') {
        try {
            const parsedDocument = new DOMParser().parseFromString(typeof processedHtml === 'string' ? processedHtml : '', 'text/html');
            if (parsedDocument !== undefined && parsedDocument !== null && parsedDocument.body !== undefined && parsedDocument.body !== null) {
                if (parsedDocument.body.textContent !== undefined && parsedDocument.body.textContent !== null && parsedDocument.body.textContent !== '') {
                    plainText = parsedDocument.body.textContent;
                } else if (parsedDocument.body.innerText !== undefined && parsedDocument.body.innerText !== null && parsedDocument.body.innerText !== '') {
                    plainText = parsedDocument.body.innerText;
                }
            }
        } catch {
            plainText = '';
        }
    }
    return isRTL(plainText) === true ? 'rtl' : 'ltr';
}

function appendMessage(type, text, options = {}) {
    const { messageId = null, suggestedResponses = [], buttons = [], isLoading = false, temporaryMessageId = null } = options;
    const processedText = type === 'user' ? (escapeHtml(text).replace(/\r\n|\r|\n/g, '<br>')) : processAIAnswer(text);
    const messageDirection = getDir(text);
    const groupId = uuidv4();

    const newMessage = {
        id: temporaryMessageId !== undefined && temporaryMessageId !== null && temporaryMessageId !== '' ? temporaryMessageId : uuidv4(),
        type,
        text: processedText,
        messageId: messageId,
        isLoading: isLoading,
        dir: messageDirection
    };

    const messageGroup = {
        groupId: groupId,
        type: type,
        messages: [newMessage],
        suggestedResponses: suggestedResponses !== undefined && suggestedResponses !== null && suggestedResponses.length > 0 ? suggestedResponses : [],
        buttons: buttons !== undefined && buttons !== null && buttons.length > 0 ? buttons : [],
        dir: messageDirection
    };

    messages.value.push(messageGroup);

    scrollToBottom();
}


function addAgentTypingPlaceholder(temporaryMessageId) {
    appendMessage('agent', '', { isLoading: true, temporaryMessageId: temporaryMessageId, showFeedbackButtons: false });
}

function removeAgentTypingIndicator() {
    isTyping.value = false;
}

function updateAgentMessageById(targetMessageId, updatedText, options = {}) {
    console.log(`[FlowPreviewChat] updateAgentMessageById called. ID: ${targetMessageId}, Options:`, options);
    console.log('[FlowPreviewChat] Messages BEFORE update by ID:', JSON.parse(JSON.stringify(messages.value)));

    const { messageId = null, suggestedResponses = [], buttons = [] } = options;

    let messageWasUpdated = false;
    for (let groupIndex = 0; groupIndex < messages.value.length; groupIndex = groupIndex + 1) {
        const messageGroup = messages.value[groupIndex];
        if (messageGroup.type === 'agent') {
            const messageIndex = messageGroup.messages.findIndex(message => message.id === targetMessageId);
            if (messageIndex !== -1) {
                console.log(`[FlowPreviewChat] Found message to update at group index ${groupIndex}, message index ${messageIndex}`);
                const messageToUpdate = messageGroup.messages[messageIndex];
                const processedText = processAIAnswer(updatedText);
                const messageDirection = getDir(updatedText);

                messageToUpdate.text = processedText;
                messageToUpdate.isLoading = false;
                messageToUpdate.messageId = messageId;
                messageToUpdate.dir = messageDirection;

                messageGroup.suggestedResponses = suggestedResponses !== undefined && suggestedResponses !== null && suggestedResponses.length > 0 ? suggestedResponses : [];
                messageGroup.buttons = buttons !== undefined && buttons !== null && buttons.length > 0 ? buttons : [];
                messageGroup.dir = messageDirection;

                messageWasUpdated = true;
                break;
            }
        }
    }

    if (messageWasUpdated === false) {
        console.warn(`[FlowPreviewChat] Could not find message with temp ID ${targetMessageId} to update. Appending new message instead.`);
        appendMessage('agent', updatedText, { messageId, suggestedResponses, buttons });
    }

    console.log('[FlowPreviewChat] Messages AFTER update by ID attempt:', JSON.parse(JSON.stringify(messages.value)));
    scrollToBottom();
}

function scrollToBottom() {
    nextTick(() => {
        if (chatContentRef.value !== null && chatContentRef.value !== undefined) {
            chatContentRef.value.scrollTop = chatContentRef.value.scrollHeight;
        }
    });
}

function adjustTextareaHeight(event) {
    const textarea = event.target;
    textarea.style.height = "auto";
    textarea.style.height = Math.min(textarea.scrollHeight, 100) + "px"; 
    inputDirection.value = getDir(textarea.value);
}

function handleKeyDown(event) {
    if (event.key === "Enter" && event.shiftKey === false) {
        event.preventDefault();
        sendMessage();
    }
}

async function loadAgentInfo() {
    if (props.previewData !== null) {
        isLoading.value = false;
        error.value = '';
        agentName.value = props.previewData.name !== undefined && props.previewData.name !== null && props.previewData.name !== '' ? props.previewData.name : 'AI Agent';
        agentConfig.value = {};
        chatInputPlaceholder.value = 'Type your message...';
        
        if (props.previewData.iconDataUrl !== undefined && props.previewData.iconDataUrl !== null && props.previewData.iconDataUrl !== '') {
            customLogoUrl.value = props.previewData.iconDataUrl;
            hasCustomLogo.value = true;
        }

        const primaryColor = props.previewData.primaryColor !== undefined && props.previewData.primaryColor !== null && props.previewData.primaryColor !== '' ? props.previewData.primaryColor : '#0d6efd';
        const secondaryColor = props.previewData.secondaryColor !== undefined && props.previewData.secondaryColor !== null && props.previewData.secondaryColor !== '' ? props.previewData.secondaryColor : '#6c757d';
        const textColor = props.previewData.textColor !== undefined && props.previewData.textColor !== null && props.previewData.textColor !== '' ? props.previewData.textColor : '#ffffff';
        const accentColor = props.previewData.accentColor !== undefined && props.previewData.accentColor !== null && props.previewData.accentColor !== '' ? props.previewData.accentColor : primaryColor;
        
        const styleElement = document.createElement('style');
        styleElement.textContent = `.chat-agent-container-preview { --primary: ${primaryColor}; --secondary: ${secondaryColor}; --text-on-primary: ${textColor}; --accent: ${accentColor}; }`;
        document.head.appendChild(styleElement);

        return { startingMessage: props.previewData.startingMessage };
    }

    if (props.agentId === undefined || props.agentId === null) return;
    isLoading.value = true;
    error.value = '';
    try {
        const agentInfoResponse = await axios.get(`${globalState.apiEndpoint}/agents/getPublicAIChatInfo/${props.agentId}`);
        const agentInfo = agentInfoResponse.data;

        if (agentInfo === undefined || agentInfo === null || agentInfo.agenttype === 'PrivateAgent' || agentInfo.agentStatus !== 'active') {
            throw new Error((agentInfo?.agenttype === 'PrivateAgent' ? 'Private agent access restricted.' : 'Agent is inactive or data not found.'));
        }

        agentName.value = agentInfo.name !== undefined && agentInfo.name !== null && agentInfo.name !== '' ? agentInfo.name : 'AI Agent';
        agentConfig.value = agentInfo.configurations !== undefined && agentInfo.configurations !== null ? agentInfo.configurations : {};
        chatInputPlaceholder.value = agentInfo.chatinputplaceholder?.trim().length > 0 ? agentInfo.chatinputplaceholder.trim() : 'Type your message...';

        await loadAgentStyle(agentInfo.styleGuid);

        return agentInfo;

    } catch (agentInfoError) {
        console.error('Error loading agent info in preview:', agentInfoError);
        error.value = (agentInfoError.message !== null && agentInfoError.message !== undefined && agentInfoError.message.length > 0) ? agentInfoError.message : 'Error loading agent configuration.';
        isLoading.value = false;
        return null;
    }
}

async function loadAgentStyle(styleGuid) {
    hasCustomLogo.value = false;
    customLogoUrl.value = '';
    if (styleGuid === undefined || styleGuid === null || styleGuid === '') {
        return;
    }
    try {
        const styleResponse = await axios.get(`${globalState.apiEndpoint}/api/styles/getAgentStyle/${styleGuid}`);
        const styleData = styleResponse.data;

        if (styleData !== undefined && styleData !== null) {

            if (styleData.logobase64 !== undefined && styleData.logobase64.length > 0) {
                customLogoUrl.value = styleData.logobase64.startsWith('data:image') === true ? styleData.logobase64 : `data:image/png;base64,${styleData.logobase64}`;
                hasCustomLogo.value = true;
            }

        }
    } catch (styleError) {
        console.error('Error loading agent style in preview:', styleError);

    }
}


async function createNewChatSession() {
    if (props.previewData !== null) return false;
    if (props.agentId === undefined || props.agentId === null) return false;
    try {
        const sessionResponse = await axios.post(`${globalState.apiEndpoint}/agents/createNewPublicSession`, { agentId: props.agentId });
        const sessionData = sessionResponse.data;
        if (sessionData !== undefined && sessionData !== null && sessionData.sessionId !== undefined) {
            chatSessionId.value = sessionData.sessionId;
            console.log('Created new preview session:', chatSessionId.value);
            return true;
        } else {
            throw new Error('Invalid session creation response');
        }
    } catch (sessionCreationError) {
        console.error('Preview session creation error:', sessionCreationError);
        error.value = 'Error starting chat session.';
        return false;
    }
}

function clearLastAgentActions() {
    console.log('[FlowPreviewChat] Clearing actions from last agent message.');
    for (let messageGroupIndex = messages.value.length - 1; messageGroupIndex >= 0; messageGroupIndex--) {
        if (messages.value[messageGroupIndex].type === 'agent') {
            console.log('[FlowPreviewChat] Found last agent message group at index:', messageGroupIndex);
            messages.value[messageGroupIndex].suggestedResponses = [];
            messages.value[messageGroupIndex].buttons = [];
            break;
        }
    }
}

async function sendMessage() {
    const trimmedMessageText = userMessage.value.trim();
    if (trimmedMessageText.length === 0) return;

    clearLastAgentActions();

    const currentMessage = userMessage.value;
    userMessage.value = '';
    const chatInputElement = document.getElementById('chat-input-preview');
    if (chatInputElement !== null) {
      chatInputElement.style.height = 'auto';
    }
    inputDirection.value = 'ltr';

    appendMessage('user', currentMessage);
    const tempAgentMessageId = uuidv4();
    addAgentTypingPlaceholder(tempAgentMessageId);

    if (props.previewData !== null) {
        setTimeout(() => {
            updateAgentMessageById(tempAgentMessageId, "This is a preview mode. Chat interactions are disabled until the agent is deployed.", { messageId: tempAgentMessageId });
        }, 1000);
        return;
    }

    try {
        const queryResponse = await fetch(`${globalState.apiEndpoint}/agents/queryPublicAgent`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                question: currentMessage,
                sessionId: chatSessionId.value,
                agentId: props.agentId
            }),
        });

        if (queryResponse.ok === false) {
            let errorBody = 'Unknown error';
            try {
                errorBody = await queryResponse.text();
            } catch {  }
            throw new Error(`HTTP error! status: ${queryResponse.status}, body: ${errorBody}`);
        }

        const agentResponseData = await queryResponse.json();

        console.log('[FlowPreviewChat] Received data from /queryPublicAgent:', agentResponseData);

        if (agentResponseData !== undefined && agentResponseData !== null && agentResponseData.answer !== undefined && agentResponseData.messageId !== undefined) {
            updateAgentMessageById(tempAgentMessageId, agentResponseData.answer, {
                messageId: agentResponseData.messageId,
                suggestedResponses: agentResponseData.suggestedResponses !== undefined && agentResponseData.suggestedResponses !== null && agentResponseData.suggestedResponses.length > 0 ? agentResponseData.suggestedResponses : [],
                buttons: agentResponseData.buttons !== undefined && agentResponseData.buttons !== null && agentResponseData.buttons.length > 0 ? agentResponseData.buttons : []
            });
        } else {
            console.error('Invalid response format from /queryPublicAgent:', agentResponseData);
            updateAgentMessageById(tempAgentMessageId, 'Sorry, the response format was invalid.', { messageId: tempAgentMessageId });
            throw new Error('Invalid response format');
        }
    } catch (messageSendError) {
        console.error('Fetch error calling /queryPublicAgent in preview:', messageSendError);
        updateAgentMessageById(tempAgentMessageId, 'Sorry, there was an error processing your message.', { messageId: tempAgentMessageId });
    }
}


async function handleFeedbackClick(messageId, feedbackType) {
    if (messageId === undefined || messageId === null) return;

    const feedbackButtonElement = document.querySelector(`.chat-message-preview[data-message-id='${messageId}'] .${feedbackType}-btn-preview`);
    if (feedbackButtonElement !== null) feedbackButtonElement.disabled = true;

    try {
        await axios.post(`${globalState.apiEndpoint}/api/feedback`, { messageId, feedbackType });
        toast.info(`Feedback (${feedbackType}) submitted.`);

    } catch (feedbackError) {
        console.error('Error sending feedback in preview:', feedbackError);
        toast.error('Failed to submit feedback.');
         if (feedbackButtonElement !== null) feedbackButtonElement.disabled = false;
    }
}

function handleSuggestionClick(suggestionText) {
    if (suggestionText !== null && suggestionText.trim().length > 0) {
        clearLastAgentActions();
        userMessage.value = suggestionText;
        sendMessage();
    }
}

function handleStepButtonClick(buttonConfig) {
    console.log('Step button clicked:', buttonConfig);
    let messageToSend = buttonConfig.label; 

    clearLastAgentActions();

    if (buttonConfig.type === 'Link') {
        if (buttonConfig.action !== undefined && buttonConfig.action !== null && buttonConfig.action.trim() !== '') {
            const safeUrl = sanitizeWindowOpenUrl(buttonConfig.action);
            if (safeUrl !== null) {
                window.open(safeUrl, '_blank', 'noopener,noreferrer');
            }
        }
         
         appendMessage('user', messageToSend);
         return; 
    } else if (buttonConfig.type === 'JumpToStep') {
        if (buttonConfig.action !== undefined && buttonConfig.action !== null && buttonConfig.action.trim() !== '') {
            messageToSend = `JumpToStep:${buttonConfig.action}`;
        } else {
            console.warn('JumpToStep button clicked with no action:', buttonConfig.label);
            messageToSend = buttonConfig.label; 
        }
    }

    userMessage.value = messageToSend;
    sendMessage();
}


async function initializeChat() {
  isLoading.value = true;
  messages.value = [];
  const agentData = await loadAgentInfo();
  if (agentData !== null && error.value === '') {
    const sessionCreated = await createNewChatSession();
    if (sessionCreated === true) {
      const actionButtons = Array.isArray(agentData.actionButtons) === true ? agentData.actionButtons : [];
      appendMessage('agent', (agentData.startingMessage !== undefined && agentData.startingMessage !== null && agentData.startingMessage.length > 0 ? agentData.startingMessage : "Hi, how can I help you today?"), { buttons: actionButtons });
    }
  }
  isLoading.value = false;
}

function startNewChat() {
    messages.value = [];
    chatSessionId.value = '';
    initializeChat();
}


watch(() => props.previewData, (newPreviewData, previousPreviewData) => {
  if (newPreviewData !== previousPreviewData && newPreviewData !== null) {
    console.log('FlowPreviewChat previewData changed, re-initializing');
    startNewChat();
  }
}, { deep: true });

watch(() => props.agentId, (nextAgentId, previousAgentId) => {
  if (nextAgentId !== previousAgentId && nextAgentId !== undefined && nextAgentId !== null && props.previewData === null) {
    console.log('FlowPreviewChat agentId changed, re-initializing:', nextAgentId);
    startNewChat();
  }
}, { immediate: true });

</script>

<style scoped>

.chat-agent-container-preview * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Heebo', sans-serif;
}

.chat-agent-container-preview {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--fallback-b1, oklch(var(--b1) / 1));
  border-radius: var(--rounded-box, 1rem);
  overflow: hidden;
  position: relative;
  --primary: #0d6efd;
}

.error-message, .loading-indicator {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 10;
}
.error-message {
  color: var(--fallback-er, oklch(var(--er) / 1));
  font-weight: 500;
}


.chat-wrapper-preview {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.chat-container-preview {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--fallback-b1, oklch(var(--b1) / 1));
}


.chat-header-preview {
  background: var(--primary);
  padding: 0.75rem 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.chat-header-content-preview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row-reverse;
}

.agent-info-preview {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  overflow: hidden;
}
.agent-info-preview > * + * { margin-left: 0.75rem; }

.agent-avatar-preview {
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  background: var(--fallback-b1, oklch(var(--b1) / 1));
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--fallback-p, oklch(var(--p) / 1));
  flex-shrink: 0;
  overflow: hidden;
}
.agent-avatar-preview svg {
  width: 20px;
  height: 20px;
}


.agent-details-preview {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: hidden;
}

.agent-name-preview {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--fallback-pc, oklch(var(--pc) / 1));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.agent-status-preview {
  font-size: 0.8rem;
  color: var(--fallback-pc, oklch(var(--pc) / 1));
  opacity: 0.9;
}



.chat-content-preview {
  flex: 1 1 auto;
  padding: 1rem;
  overflow-y: auto;
  background: var(--chat-bg, #F0F7FF);
  display: flex;
  flex-direction: column;
  
  min-height: 0;
}
.chat-content-preview > * + * { margin-top: 1rem; }

.chat-message-group-preview {
  display: flex;
  flex-direction: column;
  max-width: 90%;
}

.chat-message-group-preview.agent-group {
   align-items: flex-start;
   margin-right: auto;
}

.chat-message-group-preview.user-group {
   align-items: flex-end;
   margin-left: auto;
}

.chat-message-preview {
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  box-shadow: var(--shadow-sm, 0px 2px 8px rgba(0, 0, 0, 0.05));
  word-wrap: break-word;
  max-width: 100%;
  animation: messageFadeIn 0.3s ease-out;
}

@keyframes messageFadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.chat-message-preview[dir="rtl"] { text-align: right; }
.chat-message-preview[dir="ltr"] { text-align: left; }

.chat-message-preview.user {
  background: var(--primary);
  color: var(--fallback-pc, oklch(var(--pc) / 1));
  border-bottom-right-radius: 0.25rem;
}

.chat-message-preview.agent {
  background: var(--fallback-b1, oklch(var(--b1) / 1));
  color: var(--fallback-bc, oklch(var(--bc) / 1));
  border-bottom-left-radius: 0.25rem;
}


.chat-message-preview.agent.typing {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0.5rem 1rem;
  color: var(--primary);
}
.chat-message-preview.agent.typing svg {
    height: 20px;
    width: auto;
    margin-bottom: 0.25em;
}
.chat-message-preview.agent.typing .message-content-preview {
    min-height: 20px; 
}

.message-content-preview :deep(a) {
    color: var(--fallback-p, oklch(var(--p) / 1));
    text-decoration: underline;
    word-break: break-all;
}
.chat-message-preview.user .message-content-preview :deep(a) {
    color: var(--fallback-pc, oklch(var(--pc) / 1));
    font-weight: 500;
}
.message-content-preview :deep(a:hover) {
    opacity: 0.8;
}
.message-content-preview :deep(p) {
    margin-bottom: 0.5em;
}
.message-content-preview :deep(p:last-child) {
    margin-bottom: 0;
}
.message-content-preview :deep(ul),
.message-content-preview :deep(ol) {
    margin-left: 1.5em;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}
.message-content-preview :deep(li) {
    margin-bottom: 0.25em;
}


.feedback-buttons-preview {
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-start;
}
.feedback-buttons-preview > * + * { margin-left: 0.5rem; }
.feedback-btn-preview {
  background: none;
  border: 1px solid var(--fallback-bc, oklch(var(--bc) / 0.2));
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
  color: var(--fallback-bc, oklch(var(--bc) / 0.6));
  padding: 0;
}
.feedback-btn-preview:hover {
  background-color: var(--fallback-b2, oklch(var(--b2) / 1));
  border-color: var(--fallback-bc, oklch(var(--bc) / 0.3));
}
.feedback-btn-preview.selected { background-color: #dbeafe; border-color: #93c5fd; color: #2563eb; }
.feedback-btn-preview.dislike-btn-preview.selected { background-color: #fee2e2; border-color: #fca5a5; color: #dc2626; }
.feedback-btn-preview:disabled { opacity: 0.6; cursor: not-allowed; }

.suggested-responses-container-preview {
    display: flex;
    flex-wrap: wrap;
    margin-left: -0.5rem;
    margin-top: calc(0.6rem - 0.5rem);
    margin-top: 0.6rem;
}
.suggested-responses-container-preview > * { margin-left: 0.5rem; margin-top: 0.5rem; }

.suggested-response-btn-preview {
    background-color: var(--fallback-b1, oklch(var(--b1) / 1));
    color: var(--fallback-p, oklch(var(--p) / 1));
    border: 1px solid var(--fallback-p, oklch(var(--p) / 1));
    border-radius: 1rem;
    padding: 0.3rem 0.8rem;
    font-size: 0.8rem;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;
    box-shadow: var(--shadow-sm, 0px 2px 8px rgba(0, 0, 0, 0.05));
}
.suggested-response-btn-preview:hover {
    background-color: var(--fallback-p, oklch(var(--p) / 0.9));
    color: var(--fallback-pc, oklch(var(--pc) / 1));
    border-color: transparent;
}

.step-buttons-container-preview {
    margin-top: 0.6rem;
    display: flex;
    flex-direction: column;
    
    width: 100%;
}
.step-buttons-container-preview > * + * { margin-top: 0.5rem; }
.step-button-preview {
    background-color: var(--fallback-b1, oklch(var(--b1) / 1));
    color: var(--fallback-p, oklch(var(--p) / 1));
    border: 1px solid var(--fallback-p, oklch(var(--p) / 1));
    border-radius: 1rem;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
    box-shadow: var(--shadow-sm, 0px 2px 8px rgba(0, 0, 0, 0.05));
    display: block;
    width: 100%;
    text-align: center;
}
.step-button-preview:hover {
    background-color: var(--fallback-p, oklch(var(--p) / 0.9));
    color: var(--fallback-pc, oklch(var(--pc) / 1));
    border-color: transparent;
}


.chat-form-wrapper-preview {
  padding: 0.75rem 1rem;
  background: var(--fallback-b1, oklch(var(--b1) / 1));
  border-top: 1px solid var(--fallback-b3, oklch(var(--b3) / 1));
  flex-shrink: 0;
}

.chat-form-preview { width: 100%; }

.input-wrapper-preview {
  display: flex;
  align-items: flex-end;
  background: var(--fallback-b2, oklch(var(--b2) / 1));
  border-radius: 1.5rem;
  padding: 0.5rem 0.75rem 0.5rem 0.5rem;
  border: 1px solid var(--fallback-bc, oklch(var(--bc) / 0.2));
  position: relative;
}
.input-wrapper-preview > * + * { margin-left: 0.75rem; }

.input-wrapper-preview:focus-within {
  border-color: var(--fallback-p, oklch(var(--p) / 1));
  box-shadow: 0 0 0 2px var(--fallback-p, oklch(var(--p) / 0.2));
}

.chat-form-preview textarea {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 0.875rem;
  line-height: 1.5;
  min-height: 24px;
  max-height: 100px;
  resize: none;
  padding: 0.4rem 0;
  outline: none;
  color: var(--fallback-bc, oklch(var(--bc) / 1));
  font-family: inherit;
  overflow-y: auto;
}

.chat-form-preview textarea::placeholder {
  color: var(--fallback-bc, oklch(var(--bc) / 0.5));
}
.chat-form-preview textarea[dir="rtl"] {
  text-align: right;
}
.chat-form-preview textarea[dir="ltr"] {
  text-align: left;
}

.send-button-preview {
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  background: var(--primary);
  border: none;
  color: var(--fallback-pc, oklch(var(--pc) / 1));
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background-color 0.2s ease;
  box-shadow: var(--shadow-sm, 0px 2px 8px rgba(0, 0, 0, 0.05));
}
.send-button-preview:hover {
  background: var(--fallback-p, oklch(var(--p) / 0.9));
}
.send-button-preview svg {
    width: 18px;
    height: 18px;
    fill: currentColor;
    stroke: none;
}

</style> 